import Dexie from 'dexie';
import {dexieSchema,confidentialCollections} from '../../schemas/dexie.schema.js';

export {confidentialCollections};

export const localDb=new Dexie('command-center-confidential');
localDb.version(1).stores({
  chatSessions: 'id,business,module,bot_team,created',
  chatMessages: 'id,conversation,sender_type,bot,created',
  chatSummaries: 'id,business,session,created',
  botConsultationLogs: 'id,business,message,lead_bot,consulted_bot,created',
  plans: 'id,business,source_plan,status,version,created',
  tasks: 'id,business,source_plan,status,due_date,created',
  files: 'id,business,tags,created',
  inboxMessages: 'id,business,triage_status,created',
  adCampaignBriefs: 'id,business,plan,status,created',
  businessMemory: 'id,business,module,extraction_method,created',
  agentFlows: 'id,business,bot,created',
  knowledgeSources: 'id,business,bot,source_type,ingested_status,created',
  llmProviderCredentials: 'id,provider,enabled,created'
});
// BB-3: responseCache (client-only content-addressed response cache, 24h TTL)
// added as a schema version bump so existing browsers migrate cleanly instead
// of failing to open the v1 database (Dexie requires a new version for
// additive table changes).
localDb.version(2).stores(dexieSchema);

// Wave A (projects/calendar + project tagging): projects table plus the
// `project` index on chatSessions/plans/tasks/adCampaignBriefs. Dexie applies
// new stores/indexes from the dexie.schema.js contract on this version bump —
// no data upgrade needed (existing rows simply index null project).
localDb.version(3).stores(dexieSchema);

// T4: search_index_blob table for serialized MiniSearch index persistence.
localDb.version(4).stores(dexieSchema);

export async function putLocal(collection,record) {
  if (!confidentialCollections.includes(collection)) {
    throw new Error(`${collection} is not a local confidential collection.`);
  }

  return localDb.table(collection).put(record);
}

export async function addLocal(collection,record) {
  if (!confidentialCollections.includes(collection)) {
    throw new Error(`${collection} is not a local confidential collection.`);
  }

  return localDb.table(collection).add(record);
}

export async function getLocal(collection,id) {
  return localDb.table(collection).get(id);
}

export async function listLocal(collection) {
  return localDb.table(collection).toArray();
}

export async function updateLocal(collection,id,patch) {
  await localDb.table(collection).update(id,patch);
  return getLocal(collection,id);
}

export async function deleteLocal(collection,id) {
  return localDb.table(collection).delete(id);
}